// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--KffP7","icon":"icon--2h7VK","button":"button--2jlrQ"};